export default __webpack_public_path__ + "static/media/logo-card-1920w.fe1b6060.webp";